import store from '../redux/store';
import { WISHLIST_FEATURE_STATUS } from 'src/constants/wishlist';

export function isWishlistUnlockedAndActive() {
  const stateData = store.getState();
  const isWishlistEnabled = stateData?.storeReducer?.store?.services?.wishlist_flag;
  const isWishlistSubscribed =
    stateData?.commonReducer.featureLocksData.featureLocks?.wishlist;

  return (
    isWishlistEnabled === WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE &&
    !isWishlistSubscribed?.isLocked
  );
}
